import { render, staticRenderFns } from "./competitionWorks.vue?vue&type=template&id=2c00a60e&scoped=true&lang=html&"
import script from "./competitionWorks.vue?vue&type=script&lang=js&"
export * from "./competitionWorks.vue?vue&type=script&lang=js&"
import style0 from "./competitionWorks.vue?vue&type=style&index=0&id=2c00a60e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00a60e",
  null
  
)

export default component.exports